

// *************************** Import CSS *************************** //

import '@styles/main.scss';
import "./ss2024-feature.css";

// *************************************************** Insert Spring Sessions 2024 Feature **************************************************** //

class SS2024Feature extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

<!-- *********************************** BEGIN: SPRING 2024 SATURDAY SESSIONS *************************************** -->

  <div class="ss24-container container">


    <!-- ************** BEGIN: Title of Section ************** -->

    <div class="container">
  
      <div class="col-lg-12 text-center mb-4">

        <span class="col-3 col-md-2 col-lg-1 badge badge-dark-purple text-white mt-4">
          <img src="assets/icons/white-brackets.png" height="30px" alt="html brackets">
        </span>

        <div class="row col-12 d-flex justify-content-center text-center mx-auto mt-2">

          <p class="col-12 col-md-6 section-title-size serif-heading bold text-center text-md-end p-0 m-0 text-white">
              Spring 2024
          </p>

          <p class="col-12 col-md-6 section-title-size serif-heading bold text-center text-md-start p-0 ps-md-2 m-0 text-white">
              Saturday Sessions
          </p>

        </div>

        <p class="section-title-size serif-heading bold mx-auto text-center mt-0 pt-0 pb-0 mb-2 text-white">
            A Banner Moment for Website Animation
        </p>

      </div>

    </div>

    <!-- ************** END: Title of Section ************** -->


    <!-- ************** BEGIN: Animated PacMan Banner ************** -->

    <div class="container-fluid banner-container">

      <div class="row col-12 col-lg-12 d-flex justify-content-center text-center mx-auto">

        <div class="banner col-lg-12">

          <div class="banner-background">                   
        
          <!----------------- Chaser ----------------->
        
          <div class="chaser"></div>              
          
          <!--------------- Begin: Runner ------------->
          
          <div class="runner">                
            
            <div class="eyes"></div>            
          
            <div class="clothes"></div>           
          
          </div>                        
          
          <!---------------- End: Runner --------------->
          
          </div>                          

        </div>

      </div>

    </div>

    <!-- ********** END: Animated PacMan Banner ********** -->


    <!-- ************* BEGIN: Spring 2024 Saturday Sessions Description *********** -->

    <div class="container my-5 text-white">

      <div class="col-12 col-lg-10 mx-auto">
        
        <!-- Dynamic Split Row: Text Left, Student Image Right -->

        <div class="row g-4 align-items-center mb-5">
          
          <!-- Text Blocks Column -->
          <div class="col-12 col-lg-6">

            <p class="ss24-text leading-relaxed text-off-white text-start bold mb-3">
              Earlier this spring Girls Code Savannah once again partnered with 
              <a class="text-bright-blue serif-heading text-size-h3 bold text-decoration-none" href="https://liveoakpl.org" target="_blank">Live Oak Public Libraries</a>
              to hold our FREE "Saturday Sessions" at different library locations across Savannah. 
              The sessions took place from 11:00 AM ‐ 1:30 PM on four Saturdays throughout March & April.
            </p>

            <p class="ss24-text leading-relaxed text-off-white text-start bold m-0">
              20 - 30 students attended each of the four Saturday Sessions. Our beginner students used HTML & CSS coding languages to 
              <a class="text-bright-blue serif-heading text-size-h3 bold text-decoration-none" href="/student-websites">build their own websites</a>
              from a blank screen. Our returning students continued evolving their 
              <a class="text-bright-blue serif-heading text-size-h3 bold text-decoration-none" href="/student-websites">already-created websites</a> 
              by learning how to code animated banners like the PacMan banner seen above.
            </p>

          </div>

          <!-- Styled Image Column -->
          <div class="col-12 col-lg-6 text-center">
            <div class="photo-wrapper p-2 bg-white rounded-3 shadow">
              <img class="img-fluid pacman-photo rounded-2" src="assets/spring-sessions-2024/ss2024-pacman-student-photo.png" alt="photo of students coding">
            </div>
          </div>

        </div>

        <!-- Thank You Block -->
        <div class="cta-block p-4 rounded-4 text-center mb-5 shadow-sm">
          <p class="ss24-text leading-relaxed text-off-white bold m-0">
            As always, we are incredibly thankful to our generous sponsors and partners who support our efforts to 
            get students animated about building their own technology.
          </p>
        </div>

      </div>

    </div>

    <!-- *************** END: Spring 2024 Saturday Sessions Description ************ -->

    <!-- *************** BEGIN: Spring 2024 Sponsors ************ -->

    <div class="col-12 text-center mx-auto mt-2 mb-5">    

      <div class="container">

        <div class="d-flex justify-content-center mb-4">
          <p class="thank-you-text serif-heading bold mx-auto text-center m-2 text-white">
            Thank You to Our Spring 2024 Sponsors & Partners!
          </p>
        </div>

        <!-- BEGIN: Sponsor Logo Section -->
        <div class="row g-3 justify-content-center align-items-center text-center">

          <!-- 1. City of Savannah -->
          <div class="col-6 col-tablet-5 col-md-3 col-lg-2">
            <a href="https://savannahga.gov" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
              <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/city-of-savannah.png" alt="city of savannah logo">
            </a>
          </div>

          <!-- 2. Live Oak Libraries -->
          <div class="col-6 col-tablet-5 col-md-3 col-lg-2">
            <a href="https://liveoakpl.org" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
              <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/live-oak-public-libraries.png" alt="live oak libraries logo">
            </a>
          </div>

          <!-- 3. Howmet Aerospace -->
          <div class="col-6 col-tablet-5 col-md-3 col-lg-2">
            <a href="https://www.howmet.com/foundation" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
              <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/howmet-aerospace.png" alt="howmet aerospace logo">
            </a>
          </div>
            
          <!-- 4. Howmet Women's Network -->
          <div class="col-6 col-tablet-5 col-md-3 col-lg-2">
            <a href="https://www.howmet.com/diversity-equity-inclusion" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
              <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/howmet-womens-network.png" alt="howmet women's network logo">
            </a>
          </div>

        </div>
        <!-- END: Sponsor Logo Section -->

      </div>

    </div>

    <!-- *************** END: Spring 2024 Sponsors ************ -->     

  </div> 

<!-- *********************************** END: SPRING 2024 SATURDAY SESSIONS ***************************************** -->

    `
  }
}


// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('ss2024-feature', SS2024Feature);